<app-reports
  title="WAG Billing API Reports"
  [filtersForm]="filtersForm"
  [reportsUrl]="reportsUrl">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">

      <app-report-month-range-option
        label="Billing Date"
        name="billingDate"
        formControlName="billingDate"
        [required]="true"
        [minYear]="2018"
        [maxYear]="maxYear"
        />

    </ng-container>
  </ng-template>

</app-reports>
